import { registerApplication, start } from "single-spa";
import { AppNames } from "../types/singleSpa.types";

const isCartPath = (pathname: string): boolean => pathname.includes("/cart/");
const isWishlistPath = (pathname: string): boolean => pathname.includes("/merkliste/");

registerApplication({
	name: "mf-cart" as AppNames,
	app: () => import("cart/MainCart"),
	activeWhen: ({ pathname }) => isCartPath(pathname),
});

registerApplication({
	name: "mf-productlist" as AppNames,
	app: () => import("productlist/PdpPlp"),
	activeWhen: ({ pathname }) => !isCartPath(pathname) && !isWishlistPath(pathname),
});

registerApplication({
	name: "mf-wishlist" as AppNames,
	app: () => import("wishlist/Wishlist"),
	activeWhen: ({ pathname }) => isWishlistPath(pathname),
});

start({
	urlRerouteOnly: true,
});
